// @ts-check
/** @typedef {import('types/menu').MenuItem} MenuItem */
/** @typedef {import('types/menu').Category} Category */

import menuData from "data/menuData.json";
import categoryData from "data/categoryData.json";

/**
 * Hook to access menu data
 * @returns {{ menuItems: MenuItem[], signatureItems: MenuItem[], categories: Category[] }}
 */
export const useMenuData = () => {
  /** @type {MenuItem[]} */
  const menuItems = [...menuData].sort((a, b) => {
    // Primary: sort by code if both items have codes
    if (a.code && b.code) {
      return a.code.localeCompare(b.code, undefined, { numeric: true });
    }
    // If only one has a code, code comes first
    if (a.code) return -1;
    if (b.code) return 1;

    // Secondary: sort by sortOrder if available
    if (a.sortOrder !== undefined && b.sortOrder !== undefined) {
      return a.sortOrder - b.sortOrder;
    }
    if (a.sortOrder !== undefined) return -1;
    if (b.sortOrder !== undefined) return 1;

    // Fallback: sort by id (for backwards compatibility)
    return a.id - b.id;
  });

  const signatureItems = menuItems
    .filter((item) => item.signatureMetadata != null)
    .sort(
      (a, b) => a.signatureMetadata.displayOrder - b.signatureMetadata.displayOrder
    );

  /** @type {Category[]} */
  const categories = categoryData.categories;

  return { menuItems, signatureItems, categories };
};
